<script>
import Layout from '@layouts/main'

import {AxiosHelper} from '@src/utils/utils';

import VueLadda from 'vue-ladda'

export default {
	components: { Layout, VueLadda },
  data() {
    return {
			title: '다운로드 관리',

			cookie : '',
			albumLink : [],
			selectAlbum : '',
			count : 0,
			totalCount : 0,
			progress : '',
			downloadList : [],

			sources : [],
			selectedDirs : '',
			targets : [],
			targetsToggleState : [],
			keyList : {},
			intervalCheck : null,
    }
	},
	mounted() {
		this.getCookie();
		this.getSource();
		this.getTargets();
	},
	methods : {
		getCookie : function() {
			AxiosHelper.get('/api/music/navercookie').then(ret => {
				this.cookie = ret.data;
			});

		},

		start() {
			this.pushMessage('네이버 연결중');

			AxiosHelper.post(`/api/naver/music/album`, {
				reqstr : this.cookie
			}).then(ret => {
				this.albumLink = ret.data;
				this.selectAlbum = ret.data[0].listid;
				this.pushMessage('네이버 연결완료');
			});
		},

		dnStart() {
			this.pushMessage('앨범 목록 분석중');

			AxiosHelper.post(`/api/naver/music/album/parse`, {
				listid : this.selectAlbum
			}).then(ret => {
				this.downloadList = ret.data;

				this.count = 0;
				this.totalCount = ret.data.length;
				this.download();
			});
		},

		download() {
			if(this.downloadList.length === 0) {
				this.progress = '다운로드 완료';
				this.getSource();
				return;
			}

			const id = this.downloadList.shift();

			this.count = this.count + 1
			this.progress = '다운로드 중'
			AxiosHelper.get(`/api/naver/music/download/${id}`).then(ret => {
				this.download();
			});
		},

		getSource : function() {
			AxiosHelper.get('/api/naver/copy/source').then(ret => {
				this.sources = ret.data.reverse();
				this.selectedDirs = ret.data[0];
			});
		},

		getTargets : function() {
			AxiosHelper.get('/api/naver/copy/target').then(ret => {
				this.targets = ret.data;
				this.targetsToggleState = ret.data.map(() => { return false; })
			});
		},

		clickCopy(item, idx) {
			this.targetsToggleState = this.targetsToggleState.map((data, i) => {
				if(idx === i)
					return true;
				return data;
			});


			AxiosHelper.post('/api/naver/copy/clone', {
				nm : item,
				dirName : this.selectedDirs
			}).then(ret => {
				this.pushMessage('작업대기열 추가');
				this.keyList[ret.data.key] = idx;

				this.intervalCheck = setInterval(() => {
					const keys = Object.keys(this.keyList).join(',');
					AxiosHelper.get(`/api/naver/copy/clone/check`, {
						params : {
							keys : keys
						}
					}).then(ret => {
						for(let i = ret.data.length - 1; i >= 0; i--) {
							const item = ret.data[i];
							if(item.isFinish) {
								const idx = this.keyList[item.key];
								this.targetsToggleState = this.targetsToggleState.map((data, i) => {
									if(idx === i)
										return false;
									return data;
								});
						
								delete this.keyList[item.key];
							}
		
							if(Object.keys(this.keyList).length === 0) {
								clearInterval(this.intervalCheck);
								this.intervalCheck = null;
							}
						}
		
					})
				}, 1000);
			});
		},

	}
}
</script>

<template>
  <Layout>
    <C.PageHeader :title="title" />
    <C.Row>
			<C.Col lg="6">
				<C.Card>
					<C.CardHeader>
						네이버 뮤직의 리스트를 다운로드 한다. 
					</C.CardHeader>
					<C.CardBody>
						<C.Row>
							<C.Col>
								<textarea v-model="cookie" class="form-control" rows="5" style="overflow:scroll"></textarea>
							</C.Col>
						</C.Row>
						<div class="form-row align-items-center mt-2">
							<div class="col-auto">
								<button type="button" class="btn btn-blue waves-effect waves-light btn-sm"
									@click="start">네이버 연결</button>
							</div>
							<div class="col-auto">
								<select v-model="selectAlbum" class="form-control">
									<option v-for="data in albumLink" :key="data.listid" :value="data.listid">{{data.name}}</option>
								</select>
							</div>
							<div class="col-auto">
								<button type="button" class="btn btn-blue waves-effect waves-light"
									@click="dnStart">다운로드 시작</button>
							</div>
							<div class="col-auto">
								{{count}} / {{totalCount}} {{progress}}
							</div>
						</div>
					</C.CardBody>
				</C.Card>
			</C.Col>

			<C.Col lg="6">
				<C.Card>
					<C.CardHeader>
						다운받은 네이버 뮤직의 리스트를 다른 경로에 복사한다.
					</C.CardHeader>
					<C.CardBody>
						<div class="row">
							<div class="col-auto">
								<select v-model="selectedDirs" class="form-control">
									<option v-for="item in sources" :key="item" :value="item">{{item}}</option>
								</select>
							</div>
							<div class="col-auto">
								<button type="button" class="btn btn-blue waves-effect waves-light"
									@click="getSource">새로고침</button>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col-auto">
								<div class="button-list">
									<!-- <div>
										<b-button variant="primary" disabled class="ml-1">
											<b-spinner small></b-spinner>&nbsp;&nbsp;Loading...
										</b-button>
									</div> -->

									<vue-ladda v-for="(item, idx) in targets" 
										:key="item"
										:loading="targetsToggleState[idx]"
										data-size="xs"
										button-class="btn btn-success"
										data-style="expand-right"
										@click="clickCopy(item, idx)">{{item}}</vue-ladda>
									<!-- {this.state.targets.map((item, idx) => {
										return <LaddaButton loading={this.state.targetsToggleState[idx]} 
															key={item} 
															value={item} 
															onClick={this.clickCopy.bind(this, item, idx)} 
															data-size={XL}
															class="btn btn-success" 
															data-style={EXPAND_RIGHT}>{item}
														</LaddaButton>
									})} -->
								</div>
								
							</div>

						</div>
					</C.CardBody>
				</C.Card>
			</C.Col>
    </C.Row>
  </Layout>
</template>